import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ComponentesModule } from "../componentes/componentes.module";
import { IngresosRoutingModule } from "./ingresos-routing.module";

import { CajaComponent } from "./caja/caja.component";
import { AdminCajaComponent } from "./admin-caja/admin-caja.component";
import { FacturacionComponent } from "./facturacion/facturacion.component";
import { PromocionesComponent } from "./promociones/promociones.component";
import { ReportesComponent } from "./reportes/reportes.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BuscaCobrosComponent } from '../componentes/busca-cobros/busca-cobros.component';
import { CobrosComponent } from "../componentes/cobros/cobros.component";



import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { TabViewModule } from "primeng/tabview";
import { ButtonModule } from "primeng/button";
import { ProgressBarModule } from 'primeng/progressbar';
import {RadioButtonModule} from 'primeng/radiobutton';
import { PanelModule } from 'primeng/panel';
import { TableModule } from "primeng/table";
import { DropdownModule } from "primeng/dropdown";
import { InputTextModule } from "primeng/inputtext";
import {InputSwitchModule} from 'primeng/inputswitch';
import { MessagesModule } from 'primeng/messages';
import { CalendarModule } from 'primeng/calendar';
import {MultiSelectModule} from 'primeng/multiselect';
import { DatosFiscalesComponent } from './datos-fiscales/datos-fiscales.component';


@NgModule({
  declarations: [
    CajaComponent,
    AdminCajaComponent,
    FacturacionComponent,
    PromocionesComponent,
    BuscaCobrosComponent,
    CobrosComponent,
    ReportesComponent,
    DatosFiscalesComponent
 
  ],
  imports: [
    MultiSelectModule,
    CommonModule,
    IngresosRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentesModule,
    DialogModule,
    TabViewModule,
    ButtonModule,
    ProgressBarModule,
    RadioButtonModule,
    PanelModule,
    TableModule,
    DropdownModule,
    InputTextModule,
    InputSwitchModule,
    MessagesModule,
    CalendarModule,
    ConfirmDialogModule,
  ],
})
export class IngresosModule {}
